/**
 * Countries where expert mode is available
 */
export const COUNTRIES = {
  afghanistan: true,
  algeria: true,
  angola: true,
  argentina: true,
  australia: true,
  austria: true,
  bahrain: true,
  bangladesh: true,
  belgium: true,
  benin: true,
  bolivia: true,
  brazil: true,
  bulgaria: true,
  'burkina faso': true,
  burundi: true,
  cambodia: true,
  cameroon: true,
  canada: true,
  'central african republic': true,
  chad: true,
  chile: true,
  china: true,
  colombia: true,
  congo: true,
  'congo (drc)': true,
  'costa rica': true,
  "cote d'ivoire": true,
  croatia: true,
  cyprus: true,
  'czech republic': true,
  denmark: true,
  'dominican republic': true,
  ecuador: true,
  egypt: true,
  'el salvador': true,
  eritrea: true,
  estonia: true,
  ethiopia: true,
  finland: true,
  france: true,
  germany: true,
  ghana: true,
  'great britain': true,
  greece: true,
  guatemala: true,
  guinea: true,
  haiti: true,
  honduras: true,
  'hong kong sar': true,
  hungary: true,
  india: true,
  indonesia: true,
  iraq: true,
  ireland: true,
  israel: true,
  italy: true,
  jamaica: true,
  japan: true,
  jordan: true,
  kazakhstan: true,
  kenya: true,
  korea: true,
  kuwait: true,
  laos: true,
  latvia: true,
  lebanon: true,
  liberia: true,
  libya: true,
  lithuania: true,
  luxembourg: true,
  macedonia: true,
  madagascar: true,
  malawi: true,
  malaysia: true,
  mali: true,
  malta: true,
  mexico: true,
  montenegro: true,
  morocco: true,
  mozambique: true,
  nepal: true,
  netherlands: true,
  'new zealand': true,
  nicaragua: true,
  niger: true,
  nigeria: true,
  norway: true,
  oman: true,
  pakistan: true,
  panama: true,
  paraguay: true,
  peru: true,
  philippines: true,
  poland: true,
  portugal: true,
  qatar: true,
  romania: true,
  russia: true,
  rwanda: true,
  'saudi arabia': true,
  senegal: true,
  serbia: true,
  'sierra leone': true,
  singapore: true,
  slovakia: true,
  slovenia: true,
  somalia: true,
  'south africa': true,
  spain: true,
  'sri lanka': true,
  sweden: true,
  switzerland: true,
  taiwan: true,
  tanzania: true,
  thailand: true,
  'timor-leste': true,
  togo: true,
  'trinidad and tobago': true,
  tunisia: true,
  turkey: true,
  uganda: true,
  ukraine: true,
  'united arab emirates': true,
  'united states': true,
  uruguay: true,
  venezuela: true,
  vietnam: true,
  yemen: true,
  zambia: true,
  zimbabwe: true,
};
